import React from "react";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridRowModes,
} from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { generateTempRowId } from "./utils";

const StyledToolbarContainer = styled(GridToolbarContainer)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(2),
}));

export default function EditToolbar({
  setRowModesModel,
  localRows,
  setLocalRows,
  primaryKeyField,
  allowAdd = true,
}) {
  const handleAddRecord = () => {
    const newRowId = generateTempRowId();
    const newRow = {
      rowId: newRowId,
      [primaryKeyField]: null,
    };
    setLocalRows([newRow, ...localRows]);
    setRowModesModel((prev) => ({
      ...prev,
      [newRowId]: { mode: GridRowModes.Edit, fieldToFocus: "name_company" },
    }));
  };

  return (
    <StyledToolbarContainer>
      <Box sx={{ display: "flex", gap: 2 }}>
        {allowAdd && (
          <Button
            variant="contained"
            onClick={handleAddRecord}
            color="secondary"
          >
            Add Record
          </Button>
        )}
        <GridToolbarExport
          slotProps={{
            button: {
              variant: "outlined",
              size: "medium",
            },
          }}
        />
      </Box>
    </StyledToolbarContainer>
  );
}
